import { nextTick, type Directive } from 'vue'

// PrimeVue only autofocuses inside its own header, footer or content slots, which a dialog's
// container slot replaces, so focus would stay behind the modal without this. It waits a tick
// because PrimeVue records the element to refocus on close only after the dialog's contents mount.
export const vFocusOnMount: Directive<HTMLElement> = { mounted: element => nextTick(() => element.focus()) }
